import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Button from '@components/ui/ButtonV2/Button'
import ContainerV2 from '@components/ui/ContainerV2/ContainerV2'
import Media from '@components/ui/Media/Media'
import { findRichTextLink } from '@lib/findRichTextLink'
import { TwoImagesTwoTextsFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { CSSProperties, FC } from 'react'
import { ModuleProps } from '..'
import s from './TwoImagesTwoTexts.module.scss'

export type TwoImagesTwoTextsProps = {} & ModuleProps &
  TwoImagesTwoTextsFragment

const TwoImagesTwoTexts: FC<TwoImagesTwoTextsProps> = ({
  image1,
  header1,
  fontType1,
  fontType2,
  header1FontType,
  header2FontType,
  richText1,
  image2,
  richText2,
  header2,
  reversed,
  lcp,
  cTA1,
  cTA2,
  backgroundColor,
  foregroundColor,
}) => {
  return (
    <ContainerV2 backgroundColor={backgroundColor}>
      <div
        style={
          backgroundColor || foregroundColor
            ? ({
                '--user-bg-color': backgroundColor || undefined,
                '--user-fg-color': foregroundColor || undefined,
              } as CSSProperties)
            : undefined
        }
        className={s.root}
      >
        <div className={clsx(s.grid, { [s.reversed]: reversed })}>
          <div className={s.content1}>
            {/* {header1 && (<HeaderVariation headline={header1} headlineVariant={header1FontType} className={s.header} />)}
             */}
            {header1 && (
              <h2
                className={clsx(
                  fontType1?.length > 0 ? fontType1 : 'headline-4',
                  s.header,
                )}
              >
                {header1}
              </h2>
            )}
            <TrustedHtml html={richText1} />
            {cTA1 && (
              <Button as={Link} link={cTA1} size="medium" className={s.button}>
                {cTA1.name}
              </Button>
            )}
          </div>
          <Link
            link={cTA1 ?? findRichTextLink(richText1)}
            className={s.image1Container}
          >
            <Media
              mediaWithCrops={image1}
              mediaClassName={s.image}
              priority={lcp}
              sizes={
                '(max-width: 1024px) 100vw, (max-width: 1512px) 50vw, 735px'
              }
            />
          </Link>
          <Link
            link={cTA2 ?? findRichTextLink(richText2)}
            className={s.image2Container}
          >
            <Media
              mediaWithCrops={image2}
              mediaClassName={s.image}
              priority={lcp}
              sizes={
                '(max-width: 1024px) 100vw, (max-width: 1512px) 33vw, 600px'
              }
            />
          </Link>
          <div className={s.content2}>
            {/* {header2 && (<HeaderVariation headline={header2} headlineVariant={header2FontType} className={s.header} />)}
             */}
            {header2 && (
              <h2
                className={clsx(
                  fontType2?.length > 0 ? fontType2 : 'headline-4',
                  s.header,
                )}
              >
                {header2}
              </h2>
            )}
            <TrustedHtml html={richText2} />
            {cTA2 && (
              <Button as={Link} size="medium" link={cTA2} className={s.button}>
                {cTA2.name}
              </Button>
            )}
          </div>
        </div>
      </div>
    </ContainerV2>
  )
}

export default TwoImagesTwoTexts
